import { useCallback, useState } from "react";

import type * as Type from "./type";

export const useViewModel = () => {
	const [viewModel, setViewModel] = useState<Type.ViewModel>({ selectedCardID: undefined });

	/**
	 * オプションの選択
	 */
	const onSetCardIDOfOption = useCallback((cardID?: string) => {
		setViewModel((prev) => ({ ...prev, selectedCardID: cardID }));
	}, []);
	/**
	 * オプションの選択解除
	 */
	const onClearCardIDOfOption = useCallback(() => {
		setViewModel((prev) => ({ ...prev, selectedCardID: undefined }));
	}, []);

	return {
		//
		viewModel,
		// オプションの選択
		onSetCardIDOfOption,
		// オプションの選択解除
		onClearCardIDOfOption,
	};
};
